import { c as _c } from "react/compiler-runtime";
import { forwardRef } from 'react';
import { preventDefault } from '../../utils';
import type { AllowedButtonTags } from '../Button';
import IconButton from './IconButton';
import { type IconButtonProps, type IconButtonType } from './types';
const ClientIconButton = forwardRef(function ClientIconButton(t0, ref) {
  const $ = _c(13);
  let onClick_;
  let onKeyDown_;
  let onKeyUpCapture_;
  let onKeyUp_;
  let props;
  if ($[0] !== t0) {
    const {
      onKeyDown: t1,
      onKeyUp: t2,
      onKeyDownCapture: onKeyDownCapture_,
      onKeyUpCapture: t3,
      onClick: t4,
      ...t5
    } = t0;
    onKeyDown_ = t1;
    onKeyUp_ = t2;
    onKeyUpCapture_ = t3;
    onClick_ = t4;
    props = t5;
    $[0] = t0;
    $[1] = onClick_;
    $[2] = onKeyDown_;
    $[3] = onKeyUpCapture_;
    $[4] = onKeyUp_;
    $[5] = props;
  } else {
    onClick_ = $[1];
    onKeyDown_ = $[2];
    onKeyUpCapture_ = $[3];
    onKeyUp_ = $[4];
    props = $[5];
  }
  const {
    disabled
  } = props;
  const onKeyDown = disabled ? preventDefault : onKeyDown_;
  const onKeyUp = disabled ? preventDefault : onKeyUp_;
  const onKeyUpCapture = disabled ? preventDefault : onKeyUpCapture_;
  const onClick = disabled ? preventDefault : onClick_;
  const t1 = props as any;
  let t2;
  if ($[6] !== onClick || $[7] !== onKeyDown || $[8] !== onKeyUp || $[9] !== onKeyUpCapture || $[10] !== ref || $[11] !== t1) {
    t2 = <IconButton {...t1} onClick={onClick} onChange={onKeyDown} onKeyUp={onKeyUp} onKeyUpCapture={onKeyUpCapture} ref={ref} />;
    $[6] = onClick;
    $[7] = onKeyDown;
    $[8] = onKeyUp;
    $[9] = onKeyUpCapture;
    $[10] = ref;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}) as IconButtonType;
export default ClientIconButton;